module.exports = __webpack_public_path__ + "static/img/news_12.09690cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_12.jpg
// module id = 6KmX
// module chunks = 2